import { SearchBarViewModel } from '@api/index';
import { useDevice } from '@contexts/device';

import HotelSearchBar from '../components/SearchBar/HotelSearchBar';
import { Banner, Element, Title } from './HotelTicketStyle';

const HotelTicketSearchBar = ({ data }: { data: SearchBarViewModel }) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <Banner url={data?.images[0].url}>
      <Title>{data?.name}</Title>
      <Element>
        <HotelSearchBar />
      </Element>
    </Banner>
  ) : (
    <HotelSearchBar />
  );
};

export default HotelTicketSearchBar;
